import type { WeddingTimelineEvent, WeddingVendor, SeatingTable, Guest } from '../types/dayof';

export const sampleTimeline: WeddingTimelineEvent[] = [
  {
    id: '1',
    time: '2:00 PM',
    event: 'Vendor Setup Begins',
    status: 'pending',
    duration: 90,
    responsible: ['Wedding Planner', 'Venue Coordinator'],
    notes: 'All vendors should arrive and begin setup'
  },
  {
    id: '2',
    time: '3:30 PM',
    event: 'Bridal Party Photos',
    status: 'pending',
    duration: 60,
    location: 'Garden Area',
    responsible: ['Photographer'],
    notes: 'Pre-ceremony photos with bridal party'
  },
  {
    id: '3',
    time: '4:00 PM',
    event: 'Guest Arrival',
    status: 'pending',
    duration: 30,
    responsible: ['Ushers', 'Wedding Planner'],
    notes: 'Welcome drinks and seating assistance'
  },
  {
    id: '4',
    time: '4:30 PM',
    event: 'Ceremony Begins',
    status: 'pending',
    duration: 45,
    location: 'Main Ceremony Area',
    responsible: ['Officiant', 'Musician'],
    notes: 'Processional music starts at 4:25 PM'
  },
  {
    id: '5',
    time: '5:15 PM',
    event: 'Cocktail Hour',
    status: 'pending',
    duration: 75,
    location: 'Garden Terrace',
    responsible: ['Bartender', 'Catering Staff'],
    notes: 'Couple photos during cocktail hour'
  },
  {
    id: '6',
    time: '6:30 PM',
    event: 'Reception Begins',
    status: 'pending',
    duration: 30,
    location: 'Main Reception Hall',
    responsible: ['MC', 'Wedding Planner'],
    notes: 'Grand entrance and welcome speech'
  },
  {
    id: '7',
    time: '7:00 PM',
    event: 'Dinner Service',
    status: 'pending',
    duration: 90,
    responsible: ['Catering Team', 'Servers'],
    notes: 'Three-course plated dinner service'
  },
  {
    id: '8',
    time: '8:30 PM',
    event: 'Speeches & Toasts',
    status: 'pending',
    duration: 30,
    responsible: ['MC', 'Best Man', 'Maid of Honor'],
    notes: 'Keep speeches to 3-4 minutes each'
  },
  {
    id: '9',
    time: '9:00 PM',
    event: 'First Dance',
    status: 'pending',
    duration: 15,
    responsible: ['DJ', 'Lighting Technician'],
    notes: 'Special lighting for first dance'
  },
  {
    id: '10',
    time: '9:15 PM',
    event: 'Dancing & Celebration',
    status: 'pending',
    duration: 165,
    responsible: ['DJ', 'MC'],
    notes: 'Open dance floor and party music'
  }
];

export const sampleVendors: WeddingVendor[] = [
  {
    id: '1',
    name: 'Capture Moments Photography',
    contact: '+94 77 123 4567',
    role: 'Photographer',
    arrivalTime: '2:00 PM',
    setupTime: '2:00 PM - 2:30 PM',
    status: 'confirmed',
    notes: 'Will need access to bridal suite at 1:30 PM'
  },
  {
    id: '2',
    name: 'Melody Makers DJ Service',
    contact: '+94 77 234 5678',
    role: 'DJ/Music',
    arrivalTime: '3:00 PM',
    setupTime: '3:00 PM - 4:00 PM',
    status: 'confirmed',
    notes: 'Sound check at 4:15 PM before ceremony'
  },
  {
    id: '3',
    name: 'Gourmet Catering Co.',
    contact: '+94 77 345 6789',
    role: 'Catering',
    arrivalTime: '2:30 PM',
    setupTime: '2:30 PM - 4:00 PM',
    status: 'confirmed',
    notes: 'Kitchen access required from 2:00 PM'
  },
  {
    id: '4',
    name: 'Bloom & Blossom Florists',
    contact: '+94 77 456 7890',
    role: 'Florist',
    arrivalTime: '1:00 PM',
    setupTime: '1:00 PM - 3:30 PM',
    status: 'confirmed',
    notes: 'Ceremony decorations first, then reception setup'
  },
  {
    id: '5',
    name: 'Elegant Events Decoration',
    contact: '+94 77 567 8901',
    role: 'Decorator',
    arrivalTime: '12:00 PM',
    setupTime: '12:00 PM - 3:00 PM',
    status: 'confirmed',
    notes: 'Lighting setup requires early access'
  }
];

export const sampleTables: SeatingTable[] = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  capacity: 8,
  shape: 'round',
  guests: i < 3 ? [`Guest ${i * 2 + 1}`, `Guest ${i * 2 + 2}`] : [],
  position: { x: (i % 4) * 200 + 100, y: Math.floor(i / 4) * 150 + 100 }
}));

export const unassignedGuests = [
  'John Smith', 'Jane Doe', 'Robert Johnson', 'Emily Williams', 
  'Michael Brown', 'Sarah Davis', 'David Wilson', 'Lisa Anderson',
  'James Taylor', 'Mary Garcia', 'Christopher Martinez', 'Patricia Rodriguez'
];